module.exports = __webpack_public_path__ + "img/h3.b39b7cf6.png";